import {
  useSsoIntegrationSupportedMappingFieldsQuery,
  SsoMappingField,
} from 'graphql-common';

export default function useSupportedMappingFieldsOptions() {
  const { data } = useSsoIntegrationSupportedMappingFieldsQuery({
    fetchPolicy: 'cache-first',
  });
  const supportedMappingFields: SsoMappingField[] =
    data?.ssoIntegrationSupportedMappingFields ?? [];
  return { supportedMappingFields };
}
